import { DemoFeatureKey } from '../types/demo';

// Demo feature key → the route prefix a demo session is scoped to. A demo user
// may navigate anywhere under this prefix; any other route is redirected back.
export const DEMO_FEATURE_ROUTE_PREFIX: Record<DemoFeatureKey, string> = {
  'dashboard:project_screener': '/project-screener',
};

export const isPathInDemoFeature = (feature: DemoFeatureKey, pathname: string): boolean => {
  const prefix = DEMO_FEATURE_ROUTE_PREFIX[feature];
  if (!prefix) return false;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
};
